// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2SRaq","footer":"ReportModalFilter_footer__36ivQ"};